/**
 * @generated SignedSource<<b03b772da1ab0848bfc4f2b63a84dfe2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackRowTextFragment$data = {
  readonly supportDetailed: number;
  readonly " $fragmentType": "FeedbackRowTextFragment";
};
export type FeedbackRowTextFragment$key = {
  readonly " $data"?: FeedbackRowTextFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackRowTextFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackRowTextFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportDetailed",
      "storageKey": null
    }
  ],
  "type": "ProposalFeedback",
  "abstractKey": null
};

(node as any).hash = "27ad2e015827ad96af283401f5bb1730";

export default node;
